module.exports = "https://cdn-shared.mathletics.com/teacher-modules/assessments-assign/82/assets/fonts/a3e0b5f427803a187c1b62c5919196aa.ttf";